var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-datepicker',{model:{value:(_vm.modelDate),callback:function ($$v) {_vm.modelDate=$$v},expression:"modelDate"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }